import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "services/api";
import DOMPurify from "dompurify";
import CustomerReviews from "elements/CustomerReviews";
import { Helmet } from "react-helmet";
import { __ } from "services/Translator";

// components
import Faqs from "elements/Faqs";
import BottomBanner from "elements/BottomBanner";
// import Banner from "../elements/Banner";
import PricingBlock from "elements/PricingBlock";
export default function Vip(props) {
  const isAuthenticated = props.isAuthenticated;

  const [pageContent, setPageContent] = useState({});

  const getResults = async () => {
    var response = await api.get("/get-content-page", {
      page_uid: "vip",
    });
    if (response.status === 200) {
      setPageContent(response.data.content_data);
    } else {
      props.showAlert(null, response.data.message, true);
    }
  };

  useEffect(() => {
    // getResults();
  }, []);
  return (
    <>
      <Helmet>
        <title>
          {__(
            "Joker Casino | Become a VIP and get all the Rewards that go with it!"
          )}
        </title>
        <meta
          name="description"
          content={__(
            "Joker Casino! We value all our players of course, become a ViP though and get extra rewards, bonuses and more!"
          )}
        />
      </Helmet>

      <div className="vip_page">
        <section className="games_banner">
          <div className="slick_item">
            <div className="container-xxl">
              {/*  align-self-center */}
              <div className="row align-items-center">
                <div className="col-md-6">
                  <div className="banner_heading padding_top_15">
                    {__("20 Free Spins")}
                  </div>
                  <div className="banner_heading">{__("No Deposit.")}</div>
                  <div className={"banner_title_italic " + props.landingType}>
                    {__("ON ANY SLOT GAME.")}
                  </div>

                  <div className="paragraph margin_top_30">
                    {__(
                      "Register and start playing right away with 20 Free Spins on a selection"
                    )}
                  </div>
                  <div className="paragraph">
                    {__(
                      "of awesome, thrilling games. You decide which game you want to play the free spins on."
                    )}
                  </div>

                  <div className="banner_count white_border margin_top_30">
                    {props.totals && (
                      <>
                        <div className="count_area">
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalPlayers}+
                            </div>
                            <div className="paragraph">
                              {__("Players Online")}
                            </div>
                          </div>
                          <div className="single_count">
                            <div className="number">
                              {props.totals.totalGames}+
                            </div>
                            <div className="paragraph">{__("Games")}</div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="custom_btn">
                      {props.isAuthenticated ? (
                        <Link
                          to="/games/slots"
                          className={"angle_btn " + props.landingType}
                        >
                          {__("Play Now")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="red"
                            class="bi bi-arrow-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            />
                          </svg>
                        </Link>
                      ) : (
                        <Link
                          onClick={() => {
                            props.setModalSignUpPropsData(true);
                          }}
                          className={"angle_btn " + props.landingType}
                        >
                          {__("Sign Up Now")}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            fill="red"
                            class="bi bi-arrow-right"
                            viewBox="0 0 16 16"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                            />
                          </svg>
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="banner_img">
                    {props.isMobileDevice ? (
                      <img
                        alt="game image"
                        src={
                          require("assets/images/banners/vip-banner-mobile.png")
                            .default
                        }
                      />
                    ) : (
                      <img
                        // style={{ width: "80%", marginTop: "-20px" }}
                        alt="game image"
                        src="https://chimpbytes.imgix.net/vip-banner-bg.png?&dpr=1&format=auto&auto=format&w=636&h=480&max-age=2629056"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <PricingBlock {...props} />
        <BottomBanner {...props} />
        <Faqs {...props} />
      </div>

      <div className="d-none">
        {/* <Banner pageName="vip" {...props} /> */}
        <section className="banner header_banner_area">
          <div className="single_banner_area">
            <img
              className="banner_bg desktop_banner"
              src={
                require("../assets/images/banners/vip-banner-one-desktop.png")
                  .default
              }
            />

            <img
              className="banner_bg tab_banner"
              src={
                require("../assets/images/banners/vip-banner-one-tab.png")
                  .default
              }
            />

            <img
              className="banner_bg mobile_banner"
              src={
                require("../assets/images/banners/vip-banner-one-mobile.png")
                  .default
              }
            />

            <div className="container">
              <div className="banner_text_section vip_banner">
                <div className="vip_banner_text">
                  {__(
                    "start playing today and get a invite to our exclusive vip club!"
                  )}
                </div>
                {props.isAuthenticated ? (
                  <Link
                    to="/games/live-casino"
                    onClick={() => {
                      props.setModalSignUpPropsData(true);
                      setTimeout(function () {
                        props.setModalSignUpPropsData(false);
                      }, 500);
                    }}
                    className="common_btn float-left"
                  >
                    {__("Start Winning Now!")}
                  </Link>
                ) : (
                  <>
                    <Link
                      to=""
                      onClick={() => {
                        props.setModalSignUpPropsData(true);
                        setTimeout(function () {
                          props.setModalSignUpPropsData(false);
                        }, 500);
                      }}
                      className="common_btn float-left"
                    >
                      {__("Start Winning Now!")}
                    </Link>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="about">
          <div className="container">
            <div className="terms_content vip_content">
              <div className="row">
                <div className="col-md-3">
                  <div className="review_image margin_bottom_15">
                    {/* <img
                    className="width_100"
                    src={require("assets/images/home/review.png").default}
                  /> */}
                    {/* ImageIx */}
                    <img
                      className="width_100"
                      src={
                        require("assets/images/common/become-a-vip.png").default
                      }
                    />
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="page_title">{pageContent?.page_title}</div>

                  <div
                    className="paragraph white"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(pageContent.content),
                    }}
                  ></div>

                  <CustomerReviews isAuthenticated={props.isAuthenticated} />

                  {isAuthenticated || (
                    <div className="join_btn margin_top_15">
                      <Link
                        className="common_btn no_margin d-none d-xl-block"
                        to="/register"
                      >
                        {__("Join Now")}
                      </Link>
                      <Link
                        className="common_btn no_margin small d-block d-xl-none"
                        to="/register"
                      >
                        {__("Join Now")}
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
